module.exports = __webpack_public_path__ + "static/media/processing.4cf9ec79.svg";